<div id="products" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <div class="header white-fg"
      fxLayout="column" fxLayoutAlign="center center"
      fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">

      <!-- APP TITLE -->
      <div class="logo my-12 m-sm-0"
        fxLayout="row" fxLayoutAlign="start center">
        <mat-icon class="logo-icon mr-16" *fuseIfOnDom>video_library</mat-icon>
        <span class="logo-text h1" *fuseIfOnDom>{{'main.tutorial' | translate}}</span>
      </div>
      <!-- / APP TITLE -->

      <!-- SEARCH -->
      <div class="search-input-wrapper mx-12 m-md-0 width-5-10"
        fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">
        <label for="search" class="mr-8">
          <mat-icon class="secondary-text">search</mat-icon>
        </label>
        <mat-form-field floatLabel="never" fxFlex="1 0 auto" class="page-search">
          <mat-label>{{'main.search' | translate}}</mat-label>
          <input id="search" [(ngModel)]="term" matInput>
        </mat-form-field>
      </div>
      <!-- / SEARCH -->
      <div>
        @if (write) {
          <button mat-raised-button
            (click)="newType()"
            class="add-product-button mat-white-bg my-12 mt-sm-0">
            <span>{{'tutorial.new' | translate}}</span>
          </button>
        }
      </div>


    </div>
    <!-- / HEADER -->
    <!-- CONTENT CARD -->
    <div class="content-card mat-white-bg">
      <div style="overflow: auto; display: flex">
        <div class="tutorials">
          <div class="tutorial-wraper">
            @for (item of tutorials | filter:term; track item) {
              <div class="tutorial-item" (click)="show(item)">
                <section class="title">
                  <p>{{item.title}}
                    @if (write) {
                      <button (click)="editType(item, $event)"
                        style="    position: absolute; right: 15px; top: 15px" mat-fab
                        [ngStyle]="{'background-color': item.active ? 'green' : 'orange'}">
                        <mat-icon style="    color: white;">edit</mat-icon>
                      </button>
                    }
                  </p>
                </section>
                <div [innerHTML]="item.html">
                </div>
              </div>
            }
          </div>

        </div>

        @if (write) {
          <div class="tutorials-settings">
            <div cdkDropList class="example-list" (cdkDropListDropped)="drop($event)">
              @for (item of tutorials; track item) {
                <div class="example-box" cdkDrag>
                  <p><i class="material-icons">
                    open_with
                  </i>{{item.title}}</p>
                </div>
              }
            </div>
          </div>
        }
      </div>


    </div>


    <!-- / CONTENT CARD -->
  </div>
  <!-- / CENTER -->
</div>




